import React from 'react'
import Typography from '../atoms/Typography'
import { cn } from 'src/enviroment/lib/utils'
import { BillingIntervalType } from '../../types/subscription'

interface BillingIntervalToggleProps {
  value: BillingIntervalType
  onChange: (interval: BillingIntervalType) => void
}

const BillingIntervalToggle: React.FC<BillingIntervalToggleProps> = ({ value, onChange }) => {
  return (
    <div className="flex items-center justify-center gap-4">
      <Typography
        variant="base"
        className={cn(
          'cursor-pointer transition-colors',
          value === BillingIntervalType.MONTH ? 'text-light-green-500' : 'text-gray-400',
        )}
        onClick={() => onChange(BillingIntervalType.MONTH)}
      >
        Monthly
      </Typography>

      <button
        type="button"
        role="switch"
        aria-checked={value === BillingIntervalType.YEAR}
        onClick={() =>
          onChange(value === BillingIntervalType.MONTH ? BillingIntervalType.YEAR : BillingIntervalType.MONTH)
        }
        className={cn(
          'relative h-7 w-14 rounded-full transition-colors duration-200',
          value === BillingIntervalType.YEAR ? 'bg-light-green-500' : 'bg-gray-600',
        )}
      >
        <span
          className={cn(
            'absolute left-1 top-1 h-5 w-5 rounded-full bg-white transition-transform duration-200',
            value === BillingIntervalType.YEAR ? 'translate-x-7' : 'translate-x-0',
          )}
        />
      </button>

      <div className="flex items-center gap-2">
        <Typography
          variant="base"
          className={cn(
            'cursor-pointer transition-colors',
            value === BillingIntervalType.YEAR ? 'text-light-green-500' : 'text-gray-400',
          )}
          onClick={() => onChange(BillingIntervalType.YEAR)}
        >
          Yearly
        </Typography>
        <span className="rounded-full bg-light-green-500 px-2 py-0.5 text-xs font-medium text-gray-900">Save 17%</span>
      </div>
    </div>
  )
}

export default BillingIntervalToggle
